// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "accesspolicy/internalapi/v1/accesspolicy.proto" (package "accesspolicy.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs backing the access policy editor on machines and fragments: the
// API method catalog grants are authored against, and the subjects a grant can name.
//
// Every RPC is gated behind the ENABLE_ACCESS_POLICY feature flag for the
// organization it reads. Nothing here writes: the editor saves grants through the
// part's or fragment's config like any other config section.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalAccessPolicyService } from "./accesspolicy";
import type { ListGrantSubjectsResponse } from "./accesspolicy";
import type { ListGrantSubjectsRequest } from "./accesspolicy";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAPICatalogResponse } from "./accesspolicy";
import type { GetAPICatalogRequest } from "./accesspolicy";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service accesspolicy.internalapi.v1.InternalAccessPolicyService
 */
export interface IInternalAccessPolicyServiceClient {
    /**
     * GetAPICatalog returns every grantable service and its methods, plus the
     * "_machine" methods a grant's basic_connection adds.
     *
     * @generated from protobuf rpc: GetAPICatalog(accesspolicy.internalapi.v1.GetAPICatalogRequest) returns (accesspolicy.internalapi.v1.GetAPICatalogResponse);
     */
    getAPICatalog(input: GetAPICatalogRequest, options?: RpcOptions): UnaryCall<GetAPICatalogRequest, GetAPICatalogResponse>;
    /**
     * ListGrantSubjects returns every user and API key a grant can bind, with
     * display labels: everyone holding the member role over a part, or anywhere in a
     * fragment's organization. The subjects passed in are labelled and classified
     * too, so the editor can show a subject a grant still names after it stopped
     * being a member.
     *
     * @generated from protobuf rpc: ListGrantSubjects(accesspolicy.internalapi.v1.ListGrantSubjectsRequest) returns (accesspolicy.internalapi.v1.ListGrantSubjectsResponse);
     */
    listGrantSubjects(input: ListGrantSubjectsRequest, options?: RpcOptions): UnaryCall<ListGrantSubjectsRequest, ListGrantSubjectsResponse>;
}
/**
 * @generated from protobuf service accesspolicy.internalapi.v1.InternalAccessPolicyService
 */
export class InternalAccessPolicyServiceClient implements IInternalAccessPolicyServiceClient, ServiceInfo {
    typeName = InternalAccessPolicyService.typeName;
    methods = InternalAccessPolicyService.methods;
    options = InternalAccessPolicyService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * GetAPICatalog returns every grantable service and its methods, plus the
     * "_machine" methods a grant's basic_connection adds.
     *
     * @generated from protobuf rpc: GetAPICatalog(accesspolicy.internalapi.v1.GetAPICatalogRequest) returns (accesspolicy.internalapi.v1.GetAPICatalogResponse);
     */
    getAPICatalog(input: GetAPICatalogRequest, options?: RpcOptions): UnaryCall<GetAPICatalogRequest, GetAPICatalogResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAPICatalogRequest, GetAPICatalogResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListGrantSubjects returns every user and API key a grant can bind, with
     * display labels: everyone holding the member role over a part, or anywhere in a
     * fragment's organization. The subjects passed in are labelled and classified
     * too, so the editor can show a subject a grant still names after it stopped
     * being a member.
     *
     * @generated from protobuf rpc: ListGrantSubjects(accesspolicy.internalapi.v1.ListGrantSubjectsRequest) returns (accesspolicy.internalapi.v1.ListGrantSubjectsResponse);
     */
    listGrantSubjects(input: ListGrantSubjectsRequest, options?: RpcOptions): UnaryCall<ListGrantSubjectsRequest, ListGrantSubjectsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListGrantSubjectsRequest, ListGrantSubjectsResponse>("unary", this._transport, method, opt, input);
    }
}
